import { useMutation, useQueryClient } from 'react-query';

import { createVisitReport as createReport } from 'api/visitReports/createVisitReport/createVisitReport';

const useCreateVisitReport = () => {
  const queryClient = useQueryClient();

  const {
    isSuccess,
    mutate: createVisitReport,
    isLoading,
  } = useMutation(createReport, {
    onSuccess: () => {
      queryClient.invalidateQueries('visitReports');
    },
  });

  return {
    isSuccess,
    createVisitReport,
    isLoading,
  };
};

export default useCreateVisitReport;
